export default "__VITE_ASSET__370d9925__"